export default __webpack_public_path__ + "static/2-e81bb5241e374738213c209fddee336d.jpg";